var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile2User(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13338 9.05835C8.05005 9.05002 7.95005 9.05002 7.85838 9.05835C5.87505 8.99169 4.30005 7.36669 4.30005 5.36669C4.30005 3.32502 5.95005 1.66669 8.00005 1.66669C10.0417 1.66669 11.7 3.32502 11.7 5.36669C11.6917 7.36669 10.1167 8.99169 8.13338 9.05835Z",
    stroke: "#1B3F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.175 3.33331C15.7916 3.33331 17.0917 4.64165 17.0917 6.24998C17.0917 7.82498 15.8417 9.10831 14.2833 9.16665C14.2167 9.15831 14.1417 9.15831 14.0667 9.16665",
    stroke: "#1B3F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9666 12.1333C1.94993 13.4833 1.94993 15.6833 3.9666 17.025C6.25827 18.5583 10.0166 18.5583 12.3083 17.025C14.3249 15.675 14.3249 13.475 12.3083 12.1333C10.0249 10.6083 6.2666 10.6083 3.9666 12.1333Z",
    stroke: "#1B3F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.7834 16.6667C16.3834 16.5417 16.9501 16.3 17.4168 15.9417C18.7168 14.9667 18.7168 13.3584 17.4168 12.3834C16.9584 12.0334 16.4001 11.8 15.8084 11.6667",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.a17de0294d66d00de07ab3dc8399a203.svg";
export { ForwardRef as ReactComponent };